module.exports = __webpack_public_path__ + "static/media/arrow_right.32537ed2.svg";